import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=30de3396&scoped=true"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomerDashboard.vue?vue&type=style&index=0&id=30de3396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30de3396",
  null
  
)

export default component.exports